<template>
  <section>
    <v-container fluid>
      <!-- Breadcrumb and graphics -->
      <v-row>
        <v-col cols="auto" class="px-0">
          <v-btn @click="backAction" icon color="primary" fab small>
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="auto" class="d-flex align-center">
          <v-breadcrumbs :items="titleItems" class="pa-0">
            <template v-slot:item="{ item }">
              <v-breadcrumbs-item
                href="#"
                @click="backAction"
                :disabled="item.disabled"
              >
                <p
                  class="text-h6 mb-0"
                  :style="`color: ${item.disabled ? '#495057' : 'inherit'}`"
                >
                  {{ item.text }}
                </p>
              </v-breadcrumbs-item>
            </template>
          </v-breadcrumbs>
        </v-col>

        <v-col cols="auto" class="ml-auto">
          <v-switch
            v-model="isOpenGraph"
            inset
            class="mt-0"
            label="Ver gráficas"
            hide-details
          ></v-switch>
        </v-col>
      </v-row>

      <!-- Search field -->
      <v-row class="justify-end align-center" style="min-height:68px">
        <v-col cols="auto">
          <v-text-field
            v-model="search"
            @click="isOpenSearch = true"
            append-icon="mdi-magnify"
            label="Buscar"
            filled
            rounded
            dense
            single-line
            hide-details
            readonly
          ></v-text-field>
        </v-col>
      </v-row>

      <!-- Card -->
      <v-card class="shadow-1 mt-5 mt-md-10">
        <!-- Table -->
        <v-data-table
          v-if="!isOpenGraph"
          :search="search"
          :headers="headers"
          :items="detailsList"
          item-key="id"
          :loading="isLoading"
          :options.sync="options"
          :server-items-length="totalItems"
          no-data-text="No hay registros que mostrar"
          :footer-props="{
            'items-per-page-options': [15, 30, 50, 100],
          }"
        >
          <template v-slot:[`item.typification`]="{ item }">
            {{ item.typification.name || "No posee" }}
          </template>
          <template v-slot:[`item.children`]="{ item }">
            {{ item.children.name || "No posee" }}
          </template>
          <template v-slot:[`item.comments`]="{ item }">
            {{ item.comments || "Sin Comentarios" }}
          </template>
          <template v-slot:[`item.audit`]="{ item }">
            {{ item.audit | getStatus }}
          </template>

          <template v-slot:[`item.action`]="{ item }">
            <v-hover v-slot:default="{ hover }">
              <v-btn
                text
                icon
                :color="hover ? 'accent' : 'blue-grey'"
                @click.stop="openTypificationDialog(item)"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </v-hover>
          </template>
        </v-data-table>

        <!-- Gráficas -->
        <v-container v-else fluid>
          <v-row align="center" justify="center">
            <v-col cols="12" md="6" v-if="render">
              <v-card outlined>
                <v-card-text>
                  <apexchart
                    ref="chart7"
                    type="bar"
                    :options="optionsBar"
                    :series="barSeries"
                  ></apexchart>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col v-else cols="12" md="6">
              <v-skeleton-loader
                transition="scale-transition"
                class="mx-auto"
                type="card"
              >
              </v-skeleton-loader>
            </v-col>

            <v-col cols="12" md="6" v-if="render">
              <v-card outlined>
                <v-card-text>
                  <apexchart
                    ref="chart7"
                    type="bar"
                    :options="optionsBar2"
                    :series="barSeries2"
                  ></apexchart>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col v-else cols="12" md="6">
              <v-skeleton-loader
                transition="scale-transition"
                class="mx-auto"
                type="card"
              >
              </v-skeleton-loader>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-container>

    <search-dialog
      :isActive="isOpenSearch"
      @dialog:close="closeSearch"
      type="typificationList"
    />

    <typification-form
      v-if="formDialog"
      :dialog="formDialog"
      @close:dialog="closeTypificationDialog"
      :temporaryTableId="temporaryTable_id"
      :queueNumber="null"
      :isEditMode="true"
      :dataToEdit="dataEdit"
      :typificationId="typificationId"
      :requestOptions="options"
    />
  </section>
</template>

<script>
import { PbxHttpClient } from "@/services/httpclient";
import moment from "moment";
import TypificationForm from "@/views/app/agents/Typification/TypificationForm.vue";
import SearchDialog from "../../components/TypificationReport/SearchDialog.vue";
import getSearchString from "@/components/TypificationReport/getSearchString";

export default {
  name: "detailsList",
  components: { SearchDialog, TypificationForm },
  props: {
    title: {
      type: String,
    },
    queueTitle: {
      type: String,
    },
    idAgent: {
      type: Number,
    },
    idQueue: {
      type: Number,
    },
  },

  data() {
    return {
      isLoading: false,
      isOpenGraph: false,
      isOpenSearch: false,
      formDialog: false,
      render: false,
      search: "",
      searchParams: {},
      titleItems: [
        { text: this.queueTitle },
        { text: this.title, disabled: true },
      ],
      // For pagination
      totalItems: 0,
      options: {
        page: 1,
        itemsPerPage: 15,
      },
      // End for pagination
      detailsList: [],
      departmentSelected: {},
      endpoint: `/typing/report/register/agent/${this.idQueue}/${this.idAgent}`,
      graphicsEndpoint: `/typing/report/graphi/register/${this.idQueue}/${this.idAgent}`,
      headers: [
        {
          text: "Numero",
          class: "primary--text",

          align: "left",
          value: "call_number",
          width: "10%",
        },
        {
          text: "Tipo",
          class: "primary--text",

          align: "left",
          value: "type",
          width: "5%",
        },
        {
          text: "Fecha",
          class: "primary--text",

          align: "left",
          value: "created_at",
          width: "15%",
        },
        // {
        //   text: "Variable 1",
        //   align: "left",
        //   value: "variable_1",
        //   width: "10%",
        // },
        // {
        //   text: "Variable 2",
        //   align: "left",
        //   value: "variable_2",
        //   width: "10%",
        // },
        {
          text: "Tipificación",
          value: "typification",
          class: "primary--text",

          width: "10%",
          align: "center",
          sortable: false,
        },
        {
          text: "Categoría",
          class: "primary--text",

          value: "children",
          width: "10%",
          align: "center",
          sortable: false,
        },
        {
          text: "Estado",
          class: "primary--text",
          align: "left",
          value: "audit",
          width: "10%",
        },
        {
          text: "Comentario",
          class: "primary--text",

          value: "comment",
          width: "15%",
          align: "center",
          sortable: false,
        },
        {
          text: "Acciones",
          value: "action",
          class: "primary--text",
          width: "15%",
          align: "center",
          sortable: false,
        },
      ],
      optionsBar: {
        xaxis: {
          categories: [],
        },
        fill: {
          colors: ["#6D71F9"],
        },
      },
      optionsBar2: {
        xaxis: {
          categories: [],
        },
        chart: {
          stacked: true,
          toolbar: {
            show: true,
          },
          zoom: {
            enabled: true,
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            borderRadius: 10,
          },
        },
      },
      barSeries: [],
      barSeries2: [],
      dataEdit: {},
      typificationId: null,
    };
  },

  watch: {
    options: {
      handler() {
        this.getAgentsByQueue();
      },
      deep: true,
    },
    search() {
      this.getAgentsByQueue();
    },
  },

  filters: {
    getStatus(value) {
      let nameStatus;

      switch (value) {
        case 0:
          nameStatus = "No auditar";
          break;
        case 1:
          nameStatus = "En espera";
          break;
        case 2:
          nameStatus = "Auditado";
          break;

        default:
          nameStatus = "";
          break;
      }

      return nameStatus;
    },
  },

  created() {
    this.getGraphics();
  },

  methods: {
    openTypificationDialog(item) {
      this.dataEdit = {
        queue_id: item.queue_id,
        typification_id: item.typification_id,
        children_id: item.children_id,
        value: item.value,
        ext: item.ext,
        comments: item.comments,
      };

      this.typificationId = item.id;

      this.formDialog = true;
    },
    closeTypificationDialog() {
      this.formDialog = false;
    },

    async getAgentsByQueue() {
      const { page } = this.options || 1;
      const itemPerPage = this.options.itemsPerPage || 15;
      this.isLoading = true;
      try {
        const { data } = await PbxHttpClient.get(this.endpoint, {
          params: { ...this.searchParams, page, itemPerPage },
        });
        this.detailsList = data.data;
        this.totalItems = data.total;
      } catch (err) {
        this.$snotify.error("No se pudo obtener los datos.", "¡Error!");
      }
      this.isLoading = false;
    },

    async getGraphics(dateStart, dateEnd) {
      try {
        this.render = false;

        const { data } = await PbxHttpClient.get(this.graphicsEndpoint, {
          params: { dateStart, dateEnd },
        });
        const bar1Data = data.table.reduce((acc, el) => {
          return Object.keys(acc).includes(el.date)
            ? { ...acc, [el.date]: acc[el.date] + el.total_register }
            : { ...acc, [el.date]: el.total_register };
        }, {});
        this.optionsBar.xaxis.categories = Object.keys(bar1Data);
        this.barSeries = [
          {
            name: "Cantidad",
            data: Object.values(bar1Data),
          },
        ];
        this.optionsBar2.xaxis.categories = [
          ...new Set(data.table.map((el) => el.date)),
        ];
        this.barSeries2 = data.table.reduce(
          (acc, { children, total_register }) => {
            const itExist = acc.find(({ name }) => name === children.name);
            return itExist
              ? acc.map((el) =>
                  el.name === children.name
                    ? { ...el, data: [...el.data, total_register] }
                    : el
                )
              : [...acc, { name: children.name, data: [total_register] }];
          },
          []
        );

        // this.barSeries2 = ;
        this.render = true;
      } catch (err) {
        // console.log(err);
        this.$snotify.error("No se pudo obtener los datos.", "¡Error!");
      }
    },

    getChartValues(data) {
      const obj = data.reduce((acc, el) => {
        const date = moment(el.created_at).format("YYYY-MM-DD");
        return Object.hasOwnProperty.call(acc, date)
          ? { ...acc, [date]: acc[date] + 1 }
          : { ...acc, [date]: 1 };
      }, {});
      return { keys: Object.keys(obj), values: Object.values(obj) };
    },

    closeSearch(params) {
      this.searchParams = params;
      this.search =
        Object.keys(params).length === 0 ? "" : getSearchString(params);
      this.isOpenSearch = false;

      const arrayParams = this.search.split(",");
      const dateStart = arrayParams
        .find((item) => item.startsWith("desde="))
        .slice(6);
      const dateEnd = arrayParams
        .find((item) => item.startsWith("hasta="))
        .slice(6);

      if (dateStart.length > 0) this.getGraphics(dateStart, dateEnd);
    },

    backAction() {
      this.$emit("close:agent");
    },
  },
};
</script>

<style></style>
